var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"employee__input"},[_c('label',[_vm._v("Name of label")]),_c('div',[_c('input',{attrs:{"type":"text","placeholder":"First Name"}})])])
}]

export { render, staticRenderFns }